import React, {useState} from "react";
import * as Yup from 'yup';
import { Formik, Form, FieldArray, Field, getIn } from 'formik';
import { Box, Typography, Grid } from '@mui/material';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import CircularProgress from '@mui/material/CircularProgress';
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import EditDayDialog from '../../TimesheetItems/EditDayDialog';
import DayDeleteDialog from '../../TimesheetItems/DayDeleteDialog';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import ReorderIcon from '@mui/icons-material/Reorder';
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";
import {logger,checkAuthentication} from '../../utils';

export default function EditSummaryDialog({ handleEditCallback, callRefresh, data, permission }) {
    const [open, setOpen] = useState(false);
    const timerRef = React.useRef(null);
    const [isLoading, setIsLoading] = React.useState(true); 
    const [refresh, setRefresh] = React.useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [week, setWeek] = useState([]);
    const [TEProperties, setTEProperties] = useState([]);
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('would you like to approve?');
    const [warning, setWarning] = React.useState(false);

    const TaskProp = [];
    var TaskVar = [];
    const [ignored, forceupdate] = React.useReducer(x => x + 1, 0);

    const handleAlertClose = () => {
        setAlert(false);
    };

    const initialValues = {
        approvalAll: false,
        Week: week,
        TEVariables: TEProperties
    };
    logger(`Values`, initialValues)
    const validFormSchema = Yup.object({
        approvalAll: Yup
            .boolean(),
        Week: Yup.array().of(
            Yup.object().shape({

            })
            )
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            approvalAll: values.approvalAll,
            Week: values.Week
        };
        logger("onTrigger", msg)
        handleEditCallback(msg);

        handleClose();
    })

    function handleDialogCallback(childData) {

        let TimeEntry = {
            "ID": childData.ID,
            "RoleID": childData.RoleID,
            "TaskID": childData.TaskID,
            "WeekOf": moment.utc(data.WeekOf).format('YYYY-MM-DD'),
            "DayOf": childData.DayOf,
            "Hours": childData.Hours,
            "isFlaged": 0,
            "FlagType": childData.TimeType
        }

        logger(TimeEntry);
        fetch("api/Time_Entry", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "time_entry": TimeEntry,
                "time_entry_prop": childData.propList
            })
        })
        logger(childData);
        setTEProperties([])
        setIsLoading(true)
        setRefresh(true)
    };

    function handleDeleteCallback(childData) {
        fetch("api/Time_Entry", {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ID: childData.ID })
        })
        logger(childData);
        setRefresh(true)
    };

    const handleClickOpen = () => {
        setRefresh(true)
        setIsLoading(true)
        setTEProperties([])
        setOpen(true);
        wait()
    };

    const handleClose = () => {
        callRefresh()
        setTEProperties([])
        setOpen(false);
    };

    async function getTaskProp(week) {
        var newEntry;
        logger(`in getTaskProp`, week)
        week.forEach(item => {
            fetch(`/api/time_entry_prop/${item.ID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json =>
                    json.forEach(prop => { 
                    TaskProp.push(prop)
                    }))
                    //TaskProp.push(json))
            //setTaskProp(json));
            // json.forEach(item => TaskProp.push({ item })))
            

        })
        setTEProperties(TaskProp)
        logger(`TaskProps===============================`, TaskProp)
    }


    const getTimeEntryLines = (timeEntryID) => {
        if (TaskProp.length) {
            let TEV = TaskProp.flat();
            logger(`tev`, TEV)
            logger(`TEVar-ID`, timeEntryID)
           // TaskVar = TEV.filter(line => line.timeEntryID === timeEntryID)
            //logger(`TEVar-Props`,TaskProp)
            logger(`TEVar`, TEVariables)
            return <React.Fragment>
                <div > display here: {TaskVar} </div>
            </React.Fragment>
        } else (logger(`no TaskProp`))

    };


     async function loadData() {
        //logger(`/api/Week/${moment.utc(data.WeekOf).format('YYYY-MM-DD')}/${data.UserID}`)
         const response = await fetch(`/api/Week/${moment.utc(data.WeekOf).format('YYYY-MM-DD')}/${data.UserID}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setWeek(json))
    }

    const wait = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }      
        timerRef.current = setTimeout(() => {
            if (!initialValues.TEVariables.length) {
                logger(`reset refresh in wait`)
                setRefresh(true)

            }                     
        }, 1500);
        
    }
    
    React.useEffect(() => {		
		checkAuthentication();
       //logger(`in useEffect`)
        if (refresh) {
           //logger(`in Refresh`)
            const loadEdit = async () => {
                //logger(`in LoadEdit`)
                try {
                    await loadData();
                    if (!TEProperties.length) { 
                        await getTaskProp(week)
                      //  setTEProperties(TaskProp)
                    }
                 //   const parsedData = parseTaskProp(TaskProp);
                } catch (error) {
                    console.error('Error loading data:', error);
                } 
               
            }
        
              loadEdit()
 
     
           //logger(`checkweek`, initialValues.Week)
            if (initialValues.Week.length) {
                //logger(`in week length`)
              //  wait()
                setIsLoading(false)
                setRefresh(false)
            }
        }
    });

    const formatTask = (prop) => {
        var str = ''
        prop.map((Task, index) => {
            if (Task.IsDropdown) {
                str = str + `(${Task.label}: ${Task.Item})`
            } else {
                str = str + `(${Task.label}: ${Task.Data})`
            }
        })
        return str;
    }

    const checkVariables = (prop) => {
        var fail = false
        prop.map((Task, index) => {
            if (Task.TaskItemID != Task.standard) {
                fail = true
                setWarning(true)
            }
        })
        return fail;
    }

	const checkHours = (Entry, FlagType) => {
		var Hours = 0
		var HourOT = 0
		Entry.map((Day) => {
            if (Day.Task != "Lunch" && Day.Task != "Holiday" && Day.Task != "Unpaid" && Day.FlagType != 'OT' && Day.FlagType != 'HOL' && Day.FlagType != 'WND') {
				Hours += Day.Hours
			}
			if (Day.FlagType == 'OT' || Day.FlagType == 'HOL' || Day.FlagType == 'WND') {
				HourOT += Day.Hours
			}
		})
		logger(" Hours", Hours)
		logger("HourOT", HourOT)

		if (Hours > 40 ) {
			return true;
		} else if (Hours < 40 && HourOT > 0 && FlagType === 'NT') {
			return false;
		} else if (Hours < 40 && HourOT > 0 && FlagType !== 'NT') {
			return true;
		} else {
			return false;
		} 
	}
   
    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                View
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                {(open) &&
                    <DialogContent>
                        {logger ("initValues", initialValues) }
                        <Formik
                            initialValues={initialValues}
                            enableReinitialize
                            validationSchema={validFormSchema}
                            onSubmit={(values, { resetForm }) => {
                                onTrigger(values);
                                resetForm();
                                setAlert(false)
                            }}
                        >
                            {props => (
                                <Form className='FormProfileCreate' style={{ maxHeight: '80%' }} onSubmit={onTrigger}>
                                    <AppBar sx={{ position: 'relative' }}>
                                        <Toolbar>
                                            <IconButton
                                                edge="start"
                                                color="inherit"
                                                onClick={handleClose}
                                                aria-label="close"
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                            <Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div" >
                                                {data.Name}
                                            </Typography>
                                            <FormControl sx={{ m: 1 }}>
                                                <FormControlLabel
                                                    name="approvalAll"
                                                    label="Approve All"
                                                    style={{ color: 'white' }}
                                                    control={<Checkbox
                                                        checked={props.values.approvalAll}
                                                        labelStyle={{ color: 'white' }}
                                                        iconStyle={{ fill: 'white' }}
                                                        inputStyle={{ color: 'white' }}
                                                        style={{ color: 'white' }}
                                                        onChange={props.handleChange} />}
                                                />
                                            </FormControl>
                                            {(!isLoading) &&
                                                <Button
                                                    autoFocus
                                                    disabled={!permission.CanBeAssignedTo}
                                                    color="inherit"
                                                    onClick={e => {
                                                        setAlert(true)
                                                    }}>
                                                    save
                                                </Button>}
                                        </Toolbar>
                                    </AppBar>
                                    <Box>
                                        {(isLoading) &&

                                            <FormControl sx={{ m: 1, height: 200, width: 300 }}>

                                                <Box sx={{
                                                    display: 'flex',
                                                    minHeight: 200,
                                                    width: '100%',
                                                    m: 1,
                                                    alignContent: 'center'
                                                }}>
                                                    <Fade
                                                        in={(isLoading)}
                                                        style={{
                                                            transitionDelay: !isLoading ? '800ms' : '0ms',
                                                        }}
                                                        unmountOnExit
                                                    >
                                                        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                                                            <CircularProgress color="secondary" />
                                                            <CircularProgress color="success" />
                                                            <CircularProgress color="inherit" />
                                                        </Stack>
                                                    </Fade>
                                                </Box>
                                                {wait()}
                                            </FormControl>
                                        }
                                        {(!isLoading) &&
                                            <TableContainer component={Paper}>
                                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Admin Actions</TableCell>
                                                            <TableCell></TableCell>
                                                            <TableCell>Day</TableCell>
                                                            <TableCell>Hours</TableCell>
                                                            <TableCell>Role</TableCell>
                                                            <TableCell>Task</TableCell>
                                                            <TableCell padding="checkbox">Details</TableCell>
                                                            <TableCell>Flag Type</TableCell>
                                                            <TableCell>Status</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    {logger(`props`,props.values) }
                                                    <FieldArray name="propList">
                                                        {({ push, remove }) => (
                                                            <TableBody>
                                                                {props.values.Week.map((Day, index) => {
                                                                    const VerifyStatus = `Week[${index}].VerifyStatus`;
                                                                    const touchedVerifyStatus = getIn(props.touched, VerifyStatus);
                                                                    const errorVerifyStatus = getIn(props.errors, VerifyStatus);
                                                                    const IsLocked = `Week[${index}].IsLocked`;
                                                                    const dayOf = moment.utc(Day.DayOf).format('YYYY-MM-DD');
                                                                    const weekOfStart = moment.utc(data.WeekOf).format('YYYY-MM-DD');
                                                                    const weekOfEnd = moment.utc(data.WeekOf).add(6, 'day').format('YYYY-MM-DD');
                                                                    const outOfBounds = dayOf < weekOfStart || dayOf > weekOfEnd;
                                                                    if(outOfBounds) {
                                                                        setWarning(true);
                                                                    }
                                                                    // const touchedIsLocked = getIn(props.touched, VerifyStatus);
                                                                    // const errorIsLocked = getIn(props.errors, VerifyStatus);
                                                                    let comment = props.values.TEVariables.filter(prop => { return prop.timeEntryID == Day.ID});
                                                                    return (
                                                                        <>
                                                                            <TableRow>
                                                                                <TableCell width='30px'><EditDayDialog handleDialogCallback={handleDialogCallback} data={Day} taskFields={TaskProp} week={moment.utc(data.WeekOf).day("Monday").format('YYYY-MM-DD')} />
                                                                                </TableCell>
                                                                                <TableCell width='30px'>
                                                                                    <DayDeleteDialog handleDeleteCallback={handleDeleteCallback} data={Day} /> </TableCell>

                                                                                <TableCell component="th" scope="row" style={outOfBounds ? {color: "red"}:{}}>
                                                                                    <Tooltip title={outOfBounds ? "Day and Week mismatch! This entry may have the wrong date.":""}>
                                                                                        {dayOf}
                                                                                    </Tooltip>
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {Day.Hours}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {Day.Role}
                                                                                </TableCell>
                                                                                {Day.RED ? setWarning(true) : ""}
                                                                                <TableCell component="th" scope="row" style={Day.RED ? { color: "red" } : {}}>
                                                                                    <Tooltip title={Day.RED ? "outside of user's role" : ""} >
                                                                                        <Box>{Day.Task}</Box>
                                                                                    </Tooltip>
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {props.values.TEVariables.length ?
                                                                                        <Tooltip title={formatTask(comment)} >
                                                                                            {checkVariables(comment) ?
                                                                                                <ReportGmailerrorredIcon color='error' /> : <ReorderIcon color='inherit' />}
                                                                                        </Tooltip> :
                                                                                        <CircularProgress color="inherit" />}
                                                                                </TableCell>
                                                                                {checkHours(props.values.Week, Day.FlagType) ? setWarning(true) : ""}
                                                                                <TableCell component="th" scope="row" style={checkHours(props.values.Week, Day.FlagType) ? { color: "red" } : {}}>
                                                                                    {Day.FlagType}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    <FormControl sx={{ m: 1, width: 240 }}>
                                                                                        <label>

                                                                                            <Field
                                                                                                type="checkbox"
                                                                                                name={IsLocked}
                                                                                                id="outlined-IsLocked"
                                                                                                disabled
                                                                                            />
                                                                                            Submitted
                                                                                        </label>
                                                                                        <label>

                                                                                            <Field
                                                                                                hold={props.values.Week[index].VerifyStatus = `${props.values.Week[index].VerifyStatus}`}
                                                                                                disabled={!permission.CanBeAssignedTo}
                                                                                                type="radio"
                                                                                                name={VerifyStatus}
                                                                                                id="outlined-VerifyStatus"
                                                                                                labelId="outlined-VerifyStatus"
                                                                                                label="VerifyStatus"
                                                                                                onChange={props.handleChange}
                                                                                                onBlur={props.handleBlur}
                                                                                                value={"1"}
                                                                                                error={touchedVerifyStatus && Boolean(errorVerifyStatus)}
                                                                                                helperText={touchedVerifyStatus && props.errors.errorVerifyStatus}
                                                                                            />
                                                                                            Approved
                                                                                        </label>
                                                                                        <label>
                                                                                            <Field
                                                                                                disabled={!permission.CanBeAssignedTo}
                                                                                                type="radio"
                                                                                                name={VerifyStatus}
                                                                                                id="outlined-VerifyStatus"
                                                                                                labelId="outlined-VerifyStatus"
                                                                                                label="VerifyStatus"
                                                                                                onChange={props.handleChange}
                                                                                                onBlur={props.handleBlur}
                                                                                                value={"-1"}
                                                                                                error={touchedVerifyStatus && Boolean(errorVerifyStatus)}
                                                                                                helperText={touchedVerifyStatus && props.errors.errorVerifyStatus}
                                                                                            />
                                                                                            Rejected
                                                                                        </label>
                                                                                    </FormControl>
                                                                                </TableCell>
                                                                            </TableRow>

                                                                            <TableRow>
                                                                                <Collapse in={isExpanded[Day.ID]} timeout="auto" unmountOnExit>
                                                                                    { //getTimeEntryLines(Day.ID)
                                                                                    }
                                                                                    {TaskVar.map((prop, index) => {
                                                                                        return (
                                                                                          <div> data out
                                                                                                <>{prop.label}: {prop.IsDropdown ? prop.Item : prop.Data}<br /></>
                                                                                            </div>
                                                                                        )
                                                                                    })}
                                                                                </Collapse>
                                                                            </TableRow>

                                                                        </>
                                                                    )
                                                                })}
                                                            </TableBody>
                                                        )}
                                                    </FieldArray>
                                                </Table>
                                            </TableContainer>
                                        }
                                        <Dialog
                                            open={LockedAlert}
                                            onClose={handleAlertClose}
                                            aria-labelledby="L&P Lock"
                                            aria-describedby="Time Period locked for this work"
                                        >
                                            <DialogTitle id="Time Entry">
                                                {"Alert"}
                                            </DialogTitle>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    {warning ? setAlertText("There are warnings, Are you sure you want to make these changes ?") : ''}
                                                    {AlertText}
                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => { setAlert(false) }} autoFocus>No</Button>
                                                <Button onClick={props.handleSubmit}>Yes</Button>
                                            </DialogActions>
                                        </Dialog>
                                    </Box>
                                </Form>
                            )}
                        </Formik>
                    </DialogContent>
                }
            </Dialog>
        </div>
    )
}